import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20551b86"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"padding":"7px 12px 0px 16px"},
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 개인정보 처리 동의 ")
const _hoisted_3 = { class: "kakao_klip_box" }
const _hoisted_4 = { class: "row_text" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 개인정보 제3자 제공 동의 ")
const _hoisted_6 = { class: "btn_wrap" }
const _hoisted_7 = { class: "kakao_klip_box" }
const _hoisted_8 = { class: "row_text" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 개인정보 제3자 제공 동의 ")
const _hoisted_10 = { class: "kakao_klip_box" }
const _hoisted_11 = { class: "row_text" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 개인정보 제3자 제공 동의 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_modal = _resolveComponent("ag-modal")!

  return (_openBlock(), _createBlock(_component_ag_modal, {
    corner: "0",
    "model-value": _ctx.modelValue,
    height: "100%",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box, {
            mt: "safeAreaTop",
            dp: "flex",
            "align-items": "center",
            p: "3px 0px 20px 0px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box, {
                class: "ion-activatable ripple-parent",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'뒤로가기'}); _ctx.$emit('update:model-value', false)})
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text, {
                typography: "tit18b",
                color: "black"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box, {
            p: "8px 20px 0px 20px",
            dp: "flex",
            direction: "column",
            "justify-content": "space-between"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_ag_text, { typography: "main14r" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString('(카카오 클립)'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_ag_text, {
                  color: "gray3",
                  typography: "main13r"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString('카카오 클립에서 조합카드 받으시려면 동의해주세요. (선택)'), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "agree_btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'카카오 클립 동의', 'clickContent':'동의하기'}); _ctx.agreeKakaoKilp()})
                  }, " 동의하기 ")
                ])
              ], 512), [
                [_vShow, !_ctx.isAgreeThirdparty]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_ag_text, { typography: "main14r" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString('(카카오 클립)'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_ag_text, {
                  color: "gray3",
                  typography: "main13r"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formattedDate(_ctx.agreeThirdpartyAt)) + " 동의 완료 ", 1)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.isAgreeThirdparty]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_ag_text, { typography: "main14r" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString('(코리아에셋투자증권)'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_ag_text, {
                  color: "gray3",
                  typography: "main13r"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formattedDate(_ctx.negostockAgreeThirdpartyAt)) + " 동의 완료 ", 1)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.negostockAgreeThirdparty]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}